import { create } from 'zustand';

/**
 * Tracks whether a Focus-mode session is "running" so it can be minimized to a
 * header widget and resumed. Focus mode (CurrentBlockView) derives everything
 * from the live schedule + wall-clock, so there's no timer state to preserve —
 * just this flag. Not persisted (the schedule is the source of truth on reload).
 */
interface FocusSessionState {
  active: boolean;
  start: () => void;
  stop: () => void;
}

export const useFocusSessionStore = create<FocusSessionState>((set) => ({
  active: false,
  start: () => set({ active: true }),
  stop: () => set({ active: false }),
}));
